//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            raceStarted: false,
            raceEnded: false,
            activeEmojiIndex: 0,
            emojis: [
                '/images/game/w4d4/emoji_1.png',
                '/images/game/w4d4/emoji_2.png',
                '/images/game/w4d4/emoji_3.png',
                '/images/game/w4d4/emoji_4.png',
                '/images/game/w4d4/emoji_5.png',
                '/images/game/w4d4/emoji_6.png',
                '/images/game/w4d4/emoji_7.png',
                '/images/game/w4d4/emoji_8.png'
            ],
            interval: 0,
            userTeamID: 1,
            teams: [],
            runningTrackOffset: 4456,
            raceResults: [],
            raceDifficulty: 500,
            numRacesFinished: 0
        };
    },

    computed: {
        userTeam () {
            return this.teams.find(team => team.id === this.userTeamID);
        },
        opponentTeams () {
            return this.teams.filter(team => team.id !== this.userTeamID);
        },
        hasUserWonTheRace () {
            return this.raceEnded && this.raceResults[0] === this.userTeamID;
        },
        result () {
            let stars = 16;

            if (this.hasUserWonTheRace && this.numRacesFinished === 1) {
                stars += 10;
            } else if (this.hasUserWonTheRace && this.numRacesFinished === 2) {
                stars += 10;
            } else  if (this.hasUserWonTheRace && this.numRacesFinished === 3) {
                stars += 5;
            }

            return {
                stars,
                correct: 16,
                wrong: 0
            };
        }
    },

    created () {
        this.init();
    },

    destroyed () {
        this.stopRace();
    },

    methods: {
        init () {
            this.setRandomActiveEmojiIndex();

            this.runningTrackOffset = 4456;
            this.raceResults = [];

            this.teams = ['red', 'yellow', 'blue', 'green'].map((team, id) => ({
                id,
                offset: 4400,
                runners: [
                    { endOffset: 3350, currentOffset: 4400, image: `/images/game/w4d4/${team}_1.png` },
                    { endOffset: 2300, currentOffset: 3350, image: `/images/game/w4d4/${team}_2.png` },
                    { endOffset: 1250, currentOffset: 2300, image: `/images/game/w4d4/${team}_3.png` },
                    { endOffset: 200, currentOffset: 1250, image: `/images/game/w4d4/${team}_4.png` }
                ]
            }));
        },
        setRandomActiveEmojiIndex () {
            let random = _.random(0, this.emojis.length - 1);
            while (random === this.activeEmojiIndex) {
                random = _.random(0, this.emojis.length - 1);
            }

            this.activeEmojiIndex = random;
        },
        clickEmoji (index) {
            if (this.activeEmojiIndex === index) {
                let finalRunningTrackOffset = 1200;
                let distance = 262.5;

                this.run(this.userTeam, distance);

                if (this.runningTrackOffset - distance > finalRunningTrackOffset) {
                    this.runningTrackOffset -= distance;
                } else {
                    this.runningTrackOffset = finalRunningTrackOffset;
                }

                this.setRandomActiveEmojiIndex();
            }
        },
        startRace () {
            this.raceStarted = true;
            this.raceEnded = false;

            this.interval = setInterval(() => {
                this.opponentTeams.forEach((team, index) => {
                    this.run(team, _.random(80, 140));
                });
            }, this.raceDifficulty);
        },
        startNextRace () {
            this.raceDifficulty += 500;
            this.init();
            this.startRace();
        },
        run (team, distance) {
            let finalOffset = 200;

            if (team.offset - distance > finalOffset) {
                team.offset -= distance;

                let runner = team.runners.find(runner => runner.endOffset <= runner.currentOffset - distance);
                if (runner !== undefined) {
                    runner.currentOffset -= distance;
                }
            } else {
                if (!this.raceResults.includes(team.id)) {
                    team.runners[team.runners.length - 1].currentOffset = finalOffset;
                    team.offset = finalOffset;

                    this.raceResults.push(team.id);
                    if (team.id === this.userTeamID) {
                        this.stopRace();
                    }
                }
            }
        },
        stopRace () {
            this.raceStarted = false;
            this.raceEnded = true;
            this.numRacesFinished++;
            clearInterval(this.interval);
        }
    }
};
